module.exports = __webpack_public_path__ + "static/media/teoria-dos-arcos@2x2.5b714d68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/Players/teoria-dos-arcos@2x2.jpg
// module id = 307
// module chunks = 0